import * as tslib_1 from "tslib";
import { AuthService } from '../services/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { PlayerService } from '../services/player.service';
var CabinetComponent = /** @class */ (function () {
    function CabinetComponent(authService, playerService, router, route) {
        var _this = this;
        this.authService = authService;
        this.playerService = playerService;
        this.router = router;
        this.route = route;
        this.hebrewCollator = new Intl.Collator(["he", "en"], {
            usage: "sort",
            sensitivity: "base",
            ignorePunctuation: true,
            numeric: true,
        });
        this.route.params.subscribe(function (p) {
            // if this is not multiuser or not authenticated then logout
            if (!_this.user.children.length) {
                _this.logout();
            }
        });
    }
    Object.defineProperty(CabinetComponent.prototype, "user", {
        get: function () { return this.authService.user; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CabinetComponent.prototype, "currentUser", {
        get: function () { return this.authService.currentUser; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CabinetComponent.prototype, "childrenSorted", {
        get: function () {
            var _this = this;
            var children = (this.user && this.user.children) ? this.user.children : [];
            return children.slice().sort(function (a, b) {
                var aName = _this.normalizeNameForSort((a.nick || a.name || '').toString());
                var bName = _this.normalizeNameForSort((b.nick || b.name || '').toString());
                return _this.hebrewCollator.compare(aName, bName);
            });
        },
        enumerable: true,
        configurable: true
    });
    CabinetComponent.prototype.logout = function () {
        this.playerService.stop();
        this.authService.logout();
        this.router.navigateByUrl("/auth/login");
    };
    CabinetComponent.prototype.setCurrentUser = function (newUser) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(newUser.name !== this.currentUser.name && newUser.active)) return [3 /*break*/, 2];
                        this.playerService.stop();
                        newUser.isChildUser = true;
                        this.authService.setCurrentUser(newUser);
                        return [4 /*yield*/, this.playerService.start()];
                    case 1:
                        _a.sent();
                        this.router.navigateByUrl("/tab1");
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    CabinetComponent.prototype.getUserClass = function (user) {
        if (this.currentUser.name === user.name) {
            return "active";
        }
        else if (!user.active) {
            return "disabled";
        }
        else {
            return "";
        }
    };
    CabinetComponent.prototype.normalizeNameForSort = function (value) {
        var withoutMarks = value.normalize("NFKD").replace(/[\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7]/g, "");
        return withoutMarks.trim();
    };
    return CabinetComponent;
}());
export { CabinetComponent };
